// import _ from 'lodash'
import createPersistedState from 'vuex-persistedstate'

export const userSelectionStore = {
  namespaced: true,
  plugins: [createPersistedState()],

  state: {
    'rsc': [],
    'attr': [],
    'view': 'chart',
    'ci': true,
    'date': [1975, 2020], // TODO: store this one too
    'covid19': true
  }
}



// WEBPACK FOOTER //
// ./src/stores/userSelectionStore.js